<template>
  <BaseModal
    hookSufix="InstantPaymentWarnModal"
    :title="$t('message.pages.instantPaymentWarningModal.title')"
    modalWidth="480px"
    minHeight="250px"
    :smallCardPadding="true"
  >
    <template #content>
      <p
        class="text-subtitle-1 white--text mb-4"
        :class="{
          'neutral--text text--lighten-1': !$vuetify.theme.dark,
        }"
        style="line-height: 150%"
      >
        {{
          $t('message.pages.instantPaymentWarningModal.subtitle', {
            value,
          })
        }}
      </p>

      <div class="d-flex align-center">
        <div v-if="defaultSource" class="d-flex card-container">
          <img
            :src="cardsImages[`${defaultSource.brand.toLowerCase()}`]"
            width="35"
            class="rounded card-image"
          />
          <span
            class="pl-2"
            :class="{
              'neutral--text text--darken-1': $vuetify.theme.dark,
            }"
          >
            {{ capitalizeFirstLetter(defaultSource.brand) }}-{{
              defaultSource.last4
            }}
          </span>
        </div>
        <p
          class="py-2 ma-0 ml-3 white--text font-weight-medium"
          :class="{
            'neutral--text text--darken-1': !$vuetify.theme.dark,
          }"
        >
          {{
            $t('message.pages.instantPaymentWarningModal.value', {
              value,
            })
          }}
        </p>
      </div>
    </template>

    <template #card-actions>
      <div class="d-flex justify-end py-6">
        <BaseBtn type="secondary" class="mr-2" @click="handleClose">{{
          $t('message.actions.cancel')
        }}</BaseBtn>
        <BaseBtn
          type="primary"
          @click="
            $root.$emit('handleCheckout')
            handleClose()
          "
          >{{ $t('message.actions.confirmPayment') }}</BaseBtn
        >
      </div>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from './BaseModal.vue'
import BaseBtn from './BaseBtn.vue'

export default {
  name: 'instantPaymentWarnModal',
  props: ['defaultSource', 'value'],
  components: {
    BaseModal,
    BaseBtn,
  },
  data() {
    return {
      cardsImages: {
        mastercard:
          'https://js.stripe.com/v3/fingerprinted/img/mastercard-4d8844094130711885b5e41b28c9848f.svg',
        visa: 'https://js.stripe.com/v3/fingerprinted/img/visa-729c05c240c4bdb47b03ac81d9945bfe.svg',
        elo: 'https://js.stripe.com/v3/fingerprinted/img/elo-efe873e884e6c9eb817f23a120caaa3e.svg',
        american_express:
          'https://js.stripe.com/v3/fingerprinted/img/elo-efe873e884e6c9eb817f23a120caaa3e.svg',
      },
    }
  },
  methods: {
    capitalizeFirstLetter(string) {
      if (!string) return
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    handleClose() {
      this.$root.$emit('closeInstantPaymentWarnModal')
    },
  },
}
</script>

<style scoped>
.card-container {
  background: var(--v-brand-lighten2);
  border-radius: 8px;
  padding: 8px;
  min-width: max-content;
  max-height: 40px;
}
</style>
